import React from 'react';


const UserStatus = ({ big, client, supplier,children }) => {
    const qGov = client ? client.clientType === "QGov":supplier?supplier.clientTypes?.includes("QGov"):null;
    const s = qGov ? {
        backgroundImage: "url(/img/Jetbidders-Q-GOV.svg)", backgroundSize: 'contain', backgroundRepeat: 'no-repeat', height: '70px', alignItems: 'center', flex: 1, display: 'flex', 
    } : null;
    return <div style={s}>
        {!children ? big ? <h3>{client?.status}{supplier?.status}</h3> : <h6>JB{client?.status}{supplier?.status}</h6>:children}
    </div>
}

export default UserStatus; 